import type { AssetSessionPrices, UserPortfolioPosition } from '@einhaus/project314-types';
import AssetSessionPriceDisplay, { formatSessionMoney, sessionChangeColor } from '@/components/Market/AssetSessionPriceDisplay';

interface PositionExtendedHoursProps {
    position: Pick<UserPortfolioPosition, 'entityType' | 'derivativeType' | 'direction' | 'quantity'>;
    prices: AssetSessionPrices | undefined;
    isLoading: boolean;
    isError: boolean;
}

export default function PositionExtendedHours({ position, prices, isLoading, isError }: PositionExtendedHoursProps) {
    if (position.entityType !== 'Asset' || position.derivativeType === 'Future') return <span className="text-zinc-500">—</span>;
    const extended = prices?.extended;
    const stockImpact =
        !isError &&
        position.derivativeType === null &&
        extended &&
        !extended.isStale &&
        extended.change !== null &&
        Number.isFinite(position.quantity) &&
        position.quantity > 0
            ? extended.change * position.quantity * (position.direction === 'short' ? -1 : 1)
            : null;

    return (
        <div className="space-y-2">
            {position.derivativeType === 'Option' && <div className="text-xs text-zinc-400">Underlying price movement</div>}
            <AssetSessionPriceDisplay extendedOnly prices={prices} isLoading={isLoading} isError={isError} />
            {stockImpact !== null && prices && (
                <div
                    className={`text-xs ${sessionChangeColor(stockImpact)}`}
                    title="Change since regular close multiplied by your current shares, with the sign reversed for short positions. An estimate, not an opening price or realized profit."
                >
                    {formatSessionMoney(stockImpact, prices.currency, true)} on current shares (est.)
                </div>
            )}
        </div>
    );
}
